import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InitializeOrg } from '@app/user-org/state/user-org.actions';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
   selector: 'app-org-shell',
   templateUrl: './org-shell.component.html',
   styleUrls: ['./org-shell.component.scss'],
})
export class OrgShellComponent implements OnInit {
   route = inject(ActivatedRoute);
   store = inject(Store);
   orgId = '';

   private unsubscribe$ = new Subject();

   ngOnInit() {
      this.route.paramMap.pipe(takeUntil(this.unsubscribe$)).subscribe((params) => {
         const orgId = params.get('orgId');
         if (orgId && orgId !== this.orgId) {
            this.orgId = orgId;
            this.store.dispatch(InitializeOrg({ orgId }));
         }
      });
   }
}
